import Button from "@mui/material/Button";
import { Box, Stack, Typography } from "@mui/material";

import {
  FieldTextarea,
  FieldInputText,
} from "../../../../../components/Fields";

import "../../styles.css";

import { ReactComponent as IconTrash } from "../../../../../images/iconTrash.svg";
import { ReactComponent as IconEdit } from "../../../../../images/iconEdit.svg";

const OutrosExamesItem = ({
  item,
  index,
  removerExames,
  editarExames,
  readOnly,
}) => {
  return (
    <Stack
      key={index}
      sx={{
        border: "1px solid #1E729F",
        padding: "8px 16px",
        marginBottom: "16px",
        borderRadius: "5px",
        boxShadow: "0px 1px 8px 0px #00000026 !important",
      }}
    >
      <Stack
        direction="row"
        sx={{
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <Stack>
          <Stack direction="row" gap={2}>
            <Typography className="titleSection" fontSize="16px !important">
              Tipo do exame:
            </Typography>
            <Typography>{item.tipoExame}</Typography>
          </Stack>
          <Stack direction="row" gap={2}>
            <Typography className="titleSection" fontSize="16px !important">
              Modelo do exame:
            </Typography>
            <Typography> {item.modeloExame}</Typography>
          </Stack>
        </Stack>
        {!readOnly && (
          <Stack direction="row" gap="16px">
            <Button
              style={{ background: "none", border: "none" }}
              onClick={removerExames}
            >
              <IconTrash
                style={{
                  width: "24px",
                  alignSelf: "center",
                }}
              />
            </Button>

            <Button
              style={{ background: "none", border: "none" }}
              onClick={editarExames}
            >
              <IconEdit
                style={{
                  width: "24px",
                  alignSelf: "center",
                }}
              />
            </Button>
          </Stack>
        )}
      </Stack>

      <Stack>
        <Box>
          <Typography
            component="span"
            className="titleSection"
            fontSize="16px !important"
          >
            Descrição da solicitação:{" "}
          </Typography>{" "}
          <Box
            component="div"
            pl={2}
            maxHeight={"200px"}
            overflow="auto"
            dangerouslySetInnerHTML={{
              __html: item.descricaoSolicitacaoExame.replace(/\n/g, "<br>"),
            }}
          />
        </Box>
      </Stack>
    </Stack>
  );
};

export default function OutrosExames({ onSubmit, data, setData, readOnly }) {
  const handleRemoveOutrosExames = (index) => {
    setData((prevState) => ({
      ...prevState,
      solicitacaoOutrosExames: prevState.solicitacaoOutrosExames.filter(
        (_, i) => i !== index
      ),
    }));
  };

  const adicionarOutrosExames = () => {
    if (
      !data.tipoExame ||
      !data.modeloExame ||
      !data.descricaoSolicitacaoExame
    ) {
      return alert("Preencha todos os campos");
    }
    setData((prevState) => ({
      ...prevState,
      solicitacaoOutrosExames: [
        ...prevState.solicitacaoOutrosExames,
        {
          tipoExame: prevState.tipoExame,
          modeloExame: prevState.modeloExame,
          descricaoSolicitacaoExame:
            prevState.descricaoSolicitacaoExame.replace(/\r\n|\r/g, "\n"),
        },
      ],
      tipoExame: "",
      modeloExame: "",
      descricaoSolicitacaoExame: "",
    }));
  };

  return (
    <form autoComplete="off" onSubmit={onSubmit}>
      {!readOnly && (
        <Stack gap="16px">
          <FieldInputText
            label="Tipos de exame"
            value={data.tipoExame}
            setValue={(value) => {
              setData((prevState) => ({
                ...prevState,
                tipoExame: value,
              }));
            }}
          />

          <FieldInputText
            label="Modelo de exame"
            value={data.modeloExame}
            setValue={(value) => {
              setData((prevState) => ({
                ...prevState,
                modeloExame: value,
              }));
            }}
          />

          <FieldTextarea
            label="Solicitação de exame"
            value={data.descricaoSolicitacaoExame ?? ""}
            setValue={(value) => {
              setData((prevState) => ({
                ...prevState,
                descricaoSolicitacaoExame: value,
              }));
            }}
            placeholder="Descrição da solicitação do exame"
          />

          <Button
            className="buttonText"
            variant="outlined"
            name="adicionarNovoExame"
            onClick={adicionarOutrosExames}
            sx={{
              width: "200px",
              alignSelf: "end",
              textTransform: "none",
            }}
          >
            + Adicionar novo exame
          </Button>
        </Stack>
      )}

      <Stack mb="20px" gap={"16px"} mt={"16px"}>
        {data.solicitacaoOutrosExames.map((item, index) => (
          <OutrosExamesItem
            readOnly={readOnly}
            key={index}
            item={item}
            index={index}
            removerExames={() => handleRemoveOutrosExames(index)}
            editarExames={() => {
              setData((prevState) => ({
                ...prevState,
                tipoExame: item.tipoExame,
                modeloExame: item.modeloExame,
                descricaoSolicitacaoExame: item.descricaoSolicitacaoExame,
              }));
              handleRemoveOutrosExames(index);
            }}
          />
        ))}
      </Stack>

      {!readOnly && (
        <Stack
          direction="row"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mt: 3,
          }}
        >
          <Button className="buttonText cancel" variant="outlined">
            Cancelar
          </Button>
          <Button
            className="buttonText submit"
            variant="contained"
            type="submit"
            name="outrosExames"
          >
            Salvar
          </Button>
        </Stack>
      )}
    </form>
  );
}
